import { measure } from "rot-js/lib/text";

const DATE_TIMEOUT = 3000;
const MAX_LOG_SIZE = 20;

let lastLog = 0;
let logs: string[] = [];
export function clearLog() {
  logs = [];
}

export function log(msg: string) {
  if (logs.length === MAX_LOG_SIZE) {
    logs.unshift();
  }
  logs.push(msg);
  lastLog = Date.now();
}

export function getLog() {
  return logs;
}

export function getLogSize() {
  return logs.length;
}

export function isLogStale() {
  return lastLog < Date.now() - DATE_TIMEOUT;
}

export function getLast() {
  return logs[logs.length - 1];
}

export function lineCount(msg: string, width: number) {
  return measure(msg, width).height;
}
